export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const CATEGORY_COLORS = [
  '#FFD54F',
  '#FF8A65',
  '#4FC3F7',
  '#81C784',
  '#CE93D8',
  '#F06292',
  '#FFB74D',
  '#90A4AE',
];

export const mediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${API_BASE}${path}`;
};

export const authHeaders = (extra = {}) => ({
  Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
  ...extra,
});

export const prizeValueLabel = (prize) => {
  if (!prize) return '';
  if (prize.value_text) return prize.value_text;
  if (prize.prize_value_text) return prize.prize_value_text;
  const amount = prize.value_amount ?? prize.prize_value_amount;
  if (amount === undefined || amount === null || amount === '') return '';
  return String(amount);
};

export const suggestTierId = (tiers, valueAmount) => {
  const enabled = (tiers || []).filter((tier) => tier.enabled);
  if (!enabled.length) return '';
  const value = Number(valueAmount);
  const sorted = [...enabled].sort((a, b) => Number(a.cap_amount) - Number(b.cap_amount));
  if (!Number.isFinite(value)) return sorted[0].id;
  const match = sorted.find((tier) => Number(tier.cap_amount) >= value);
  return (match || sorted[sorted.length - 1]).id;
};

export const PRIZE_GAMES = [
  { id: 'all', label: 'All', paths: [], spectator: '' },
  { id: 'hol', label: 'HoL', paths: ['/higherorlower'], spectator: 'higher_or_lower' },
  { id: 'beerillioner', label: 'Beerillioner', paths: ['/beerillioner'], spectator: 'beerillioner' },
  { id: 'insta_quiz', label: 'Insta Quiz', paths: ['/quiz'], spectator: 'insta_quiz' },
  { id: 'spin', label: 'Spin the Wheel', paths: ['/spinningwheel'], spectator: 'spinning_wheel' },
  { id: 'buzzer', label: 'Buzzer', paths: ['/buzzer'], spectator: 'buzzer' },
];

export const prizeGameLabel = (id) => {
  if (!id || id === 'all') return 'All';
  return PRIZE_GAMES.find((game) => game.id === id)?.label || 'All';
};

export const prizeVisibleOnPath = (pathname, gameId, spectatorGame = '') => {
  if (!gameId || gameId === 'all') return true;
  const game = PRIZE_GAMES.find((item) => item.id === gameId);
  if (!game) return true;
  const path = String(pathname || '').split('?')[0].split('#')[0].toLowerCase();
  if (game.paths.includes(path)) return true;
  if (path === '/spectate' && spectatorGame && spectatorGame === game.spectator) return true;
  return false;
};

export const prizeIsCollage = (prize) =>
  !!prize && String(prize.prize_type || prize.kind || '').toLowerCase() === 'collage';

export const prizeIsWheel = (prize) =>
  !!prize && String(prize.prize_type || prize.kind || '').toLowerCase() === 'wheel';

export const prizeIsUnlimited = (prize) =>
  !!prize && (prizeIsCollage(prize) || prizeIsWheel(prize) || prize.unlimited || prize.quantity == null);

export const prizeInStock = (prize, openShow = null) => {
  if (!prize) return false;
  if (prizeIsCollage(prize) || prizeIsWheel(prize)) return true;
  if (openShow && Number(openShow.prize_id) === Number(prize.id)) return true;
  return prizeIsUnlimited(prize) || Number(prize.available) > 0;
};

export const prizeStockLabel = (prize) => {
  if (prizeIsCollage(prize)) return 'Show / Hide';
  if (prizeIsWheel(prize)) return 'Wheel';
  if (prizeIsUnlimited(prize)) return 'Unlimited';
  const left = Number(prize?.available);
  return `${Number.isFinite(left) ? left : 0} left`;
};

export const prizeMatchesCap = (prize, cap) => {
  if (prizeIsCollage(prize) || prizeIsWheel(prize)) return true;
  if (cap == null || cap === '' || cap === 'all') return true;
  const selected = Number(cap);
  if (!Number.isFinite(selected)) return true;
  const tierCap = Number(prize.tier_cap);
  if (Number.isFinite(tierCap) && tierCap > 0) return tierCap === selected;
  return Number(prize.value_amount) === selected;
};
